export default __webpack_public_path__ + "static/media/exclamation.b30ceae2.svg";